import { useDeleteEvent, useUpdateEvent } from './use-events';
import { useCreateForecast, useUpdateForecast } from './use-forecasts';
import { useCreateNote, useUpdateNote } from './use-notes';
import { useCreateRmRec, useUpdateRmRec } from './use-rm-recs';

type UseGridCellParams = {
  callback: () => void;
};

export function useGridCell(params: UseGridCellParams) {
  const { callback } = params;

  const hookFuncs = {
    events: {
      delete: useDeleteEvent(),
      update: useUpdateEvent(),
    },
    forecasts: {
      create: useCreateForecast(),
      update: useUpdateForecast(),
    },
    notes: {
      create: useCreateNote(),
      update: useUpdateNote(),
    },
    rmRecs: {
      create: useCreateRmRec({ callback }),
      update: useUpdateRmRec({ callback }),
    },
  };

  return hookFuncs;
}
